import { useQuery } from '@tanstack/react-query'
import { Link, useParams } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { getApiErrorMessage } from '@/lib/api-client'
import { productionApi } from '@/lib/production-api'
import { Genealogy, ProductionOutputs } from './ProductionOutputs'

export default function ProductionContainerPage() {
  const { containerId = '' } = useParams()
  const { user } = useAuth()
  const valid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(containerId)
  const trace = useQuery({
    queryKey: ['production', user?.tenant_id, user?.id, 'container', containerId],
    queryFn: () => productionApi.genealogy(containerId),
    enabled: !!user && valid,
    retry: false,
  })
  return <section className="mx-auto max-w-3xl space-y-4">
    <h1 className="text-2xl font-bold">Consultar contentor</h1>
    <p className="text-sm text-gray-600">Consulta autenticada no tenant atual. A leitura não regista consumos.</p>
    {!valid ? <p role="alert">Identificador de contentor inválido.</p>
      : trace.isPending ? <output>A carregar contentor...</output>
        : trace.isError ? <div role="alert" className="space-y-2">
          <p>{getApiErrorMessage(trace.error)}</p>
          <p>Confirme que entrou na empresa correta e que tem acesso ao posto de origem.</p>
          <button className="btn btn-secondary" onClick={() => void trace.refetch()}>Tentar novamente</button>
        </div> : <div className="space-y-4">
          <Genealogy data={trace.data} />
          <ProductionOutputs outputs={[trace.data]} disabled={trace.isFetching} />
        </div>}
    <Link className="btn btn-secondary" to="/production">Ir para Produção</Link>
  </section>
}
